import React from 'react';
import { PolicyLayout } from '../components/layout/PolicyLayout';
export function ShippingPolicyPage() {
  const sections = [{
    id: 'overview',
    title: 'Shipping Policy Overview',
    content: <>
          <p data-id="element-8178" data-mp="3nx09n4mfzarj">
            At Innova Pharmacy, we are committed to delivering your healthcare
            products safely and promptly. This Shipping Policy outlines our
            delivery services, timelines, fees, and procedures across the
            Kingdom of Saudi Arabia.
          </p>
          <p className="mt-4" data-id="element-8179" data-mp="306xn141aqx0b">
            We partner with reliable courier services to ensure your orders
            reach you in perfect condition and on time.
          </p>
        </>
  }, {
    id: 'coverage',
    title: 'Delivery Coverage',
    content: <>
          <p className="mb-4" data-id="element-8180" data-mp="2cfie2sf0lhg3">
            We currently deliver to the following areas in Saudi Arabia:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8181" data-mp="2he216w5cgza1">
            <li data-id="element-8182" data-mp="39xijo95kjtp1">
              <strong data-id="element-8183" data-mp="39vxnkf3lw2p2">Major Cities:</strong> Riyadh, Jeddah, Dammam, Makkah,
              Madinah, Khobar, Dhahran, Tabuk, Buraidah, and Al Kharj
            </li>
            <li data-id="element-8184" data-mp="314ozbxb9m44b">
              <strong data-id="element-8185" data-mp="3145gmedsjbp8">Regional Areas:</strong> Most cities and towns across all
              provinces
            </li>
            <li data-id="element-8186" data-mp="2w4j5qblfq7jl">
              <strong data-id="element-8187" data-mp="2w52mvq39grwk">Remote Areas:</strong> Delivery available with extended
              timelines
            </li>
          </ul>
          <p className="mt-4" data-id="element-8188" data-mp="2r44w4p46qpjg">
            Please enter your delivery address during checkout to confirm if we
            deliver to your area. If your location is not currently covered,
            please contact our customer service for assistance.
          </p>
        </>
  }, {
    id: 'delivery-options',
    title: 'Delivery Options',
    content: <>
          <p className="mb-4" data-id="element-8189" data-mp="gcde3nzeq8uz">
            We offer multiple delivery options to suit your needs:
          </p>
          <div className="space-y-4" data-id="element-8190" data-mp="bdijzpvzoxvk">
            <div data-id="element-8191" data-mp="ujq9fz74r5yi">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-8192" data-mp="uj6qcf5qubiw">
                Standard Delivery
              </h4>
              <ul className="list-disc pl-6 space-y-1" data-id="element-8193" data-mp="zbzryu5x13qr">
                <li data-id="element-8194" data-mp="lk33d03ghbz4">
                  <strong data-id="element-8195" data-mp="lkl7eiwd0uhl">Timeline:</strong> 1-3 business days for major cities,
                  3-5 days for other areas
                </li>
                <li data-id="element-8196" data-mp="qg0nlhhub2h6">
                  <strong data-id="element-8197" data-mp="1e7frhep9lruj">Cost:</strong> FREE for orders above SAR 200, SAR 15
                  for orders below SAR 200
                </li>
                <li data-id="element-8198" data-mp="1i90zomquthye">
                  <strong data-id="element-8199" data-mp="1i7gehnqfjbd7">Tracking:</strong> Full tracking available
                </li>
              </ul>
            </div>
            <div data-id="element-8200" data-mp="198mc1gqf3qrq">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-8201" data-mp="19835ew67wot0">Express Delivery</h4>
              <ul className="list-disc pl-6 space-y-1" data-id="element-8202" data-mp="3p0a716lvf97w">
                <li data-id="element-8203" data-mp="3oyfofyy2nt6z">
                  <strong data-id="element-8204" data-mp="3p2d8cmsh4orx">Timeline:</strong> Same-day or next-day delivery in
                  select areas
                </li>
                <li data-id="element-8205" data-mp="3mf2s0ug8qw9m">
                  <strong data-id="element-8206" data-mp="3mejavfyf0bwn">Cost:</strong> SAR 30-50 depending on location
                </li>
                <li data-id="element-8207" data-mp="3hhao122bnjp2">
                  <strong data-id="element-8208" data-mp="3hfzlt6oiyk02">Availability:</strong> Orders placed before 2:00 PM
                </li>
                <li data-id="element-8209" data-mp="3vez7c5gqqis0">
                  <strong data-id="element-8210" data-mp="3ve6bw0n8ffp6">Coverage:</strong> Major cities only
                </li>
              </ul>
            </div>
            <div data-id="element-8211" data-mp="3qfctpux030io">
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-8212" data-mp="32rbrf3qf0gbp">Store Pickup</h4>
              <ul className="list-disc pl-6 space-y-1" data-id="element-8213" data-mp="32p8rnrzgn8ts">
                <li data-id="element-8214" data-mp="2yrb2uq9lqoqx">
                  <strong data-id="element-8215" data-mp="2yrumcbewhl72">Timeline:</strong> Ready for pickup within 2-4 hours
                </li>
                <li data-id="element-8216" data-mp="3cipol4uw941o">
                  <strong data-id="element-8217" data-mp="3cj946ex2ngcj">Cost:</strong> FREE
                </li>
                <li data-id="element-8218" data-mp="37p50q5n0lqg7">
                  <strong data-id="element-8219" data-mp="37olisoxd7226">Locations:</strong> Available at select Innova
                  Pharmacy branches
                </li>
              </ul>
            </div>
          </div>
        </>
  }, {
    id: 'processing',
    title: 'Order Processing Time',
    content: <>
          <p className="mb-4" data-id="element-8220" data-mp="2smwq5ie7zpau">
            Order processing times vary based on product type:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8221" data-mp="32mxdrgj4grku">
            <li data-id="element-8222" data-mp="32m5ik6tfsvv3">
              <strong data-id="element-8223" data-mp="32lm97ehurfso">OTC Products:</strong> Processed within 2-4 hours during
              business hours
            </li>
            <li data-id="element-8224" data-mp="37fgtok5a7yst">
              <strong data-id="element-8225" data-mp="3bfhecmiz568b">Prescription Orders:</strong> Processed within 4-24 hours
              after prescription verification
            </li>
            <li data-id="element-8226" data-mp="3gd0wvympg562">
              <strong data-id="element-8227" data-mp="3gchdedhep8px">Pre-Orders:</strong> Shipped when stock becomes available
            </li>
          </ul>
          <p className="mt-4" data-id="element-8228" data-mp="3lbc1nuy57phf">
            Orders placed on weekends or public holidays will be processed on
            the next business day. You will receive an email and SMS
            notification once your order is dispatched.
          </p>
        </>
  }, {
    id: 'tracking',
    title: 'Order Tracking',
    content: <>
          <p data-id="element-8229" data-mp="d45sr2aluns7">
            Once your order is shipped, you will receive a tracking number via
            SMS and email. You can track your order in real-time through:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8230" data-mp="4a99bv8trpgh">
            <li data-id="element-8231" data-mp="48ocfyz1fufg">Your account dashboard under "My Orders"</li>
            <li data-id="element-8232" data-mp="3vin16dmtandl">
              The tracking link provided in the shipping confirmation email
            </li>
            <li data-id="element-8233" data-mp="w1ot7hizyy30">Our mobile app</li>
            <li data-id="element-8234" data-mp="s0n3brayzydp">Contacting customer service with your order number</li>
          </ul>
          <p className="mt-4" data-id="element-8235" data-mp="ryimy9vvx6wj">
            Tracking information is updated regularly and shows the current
            status and estimated delivery time of your order.
          </p>
        </>
  }, {
    id: 'delivery-process',
    title: 'Delivery Process',
    content: <>
          <p className="mb-4" data-id="element-8236" data-mp="37pepuywy99r6">
            Our delivery process ensures safe and secure delivery:
          </p>
          <ol className="list-decimal pl-6 space-y-2" data-id="element-8237" data-mp="349tvuajbhaxx">
            <li data-id="element-8238" data-mp="34ad4f0n2umza">
              <strong data-id="element-8239" data-mp="347qx9243m9hl">Dispatch Notification:</strong> You receive confirmation
              when your order leaves our facility
            </li>
            <li data-id="element-8240" data-mp="2v9yhxxydn1u7">
              <strong data-id="element-8241" data-mp="2v83yyp6o1jsr">En Route Updates:</strong> Track your package in real-time
              as it moves toward you
            </li>
            <li data-id="element-8242" data-mp="30acsbmnganve">
              <strong data-id="element-8243" data-mp="2ljc7sj9fj3iw">Delivery Attempt:</strong> Our courier will attempt
              delivery at your specified address
            </li>
            <li data-id="element-8244" data-mp="2qb4131jyzncq">
              <strong data-id="element-8245" data-mp="2qbn83n830rbz">Delivery Confirmation:</strong> You will receive
              confirmation once delivered
            </li>
            <li data-id="element-8246" data-mp="2cgkx4lodobsb">
              <strong data-id="element-8247" data-mp="2gk9535gx99e3">Signature Required:</strong> For prescription orders, a
              signature may be required
            </li>
          </ol>
          <p className="mt-4" data-id="element-8248" data-mp="22lsvn6rod4s9">
            If you are not available during delivery, the courier will attempt
            to contact you. You may also arrange for a neighbor or family member
            to receive the package on your behalf.
          </p>
        </>
  }, {
    id: 'special-handling',
    title: 'Special Handling for Medications',
    content: <>
          <p data-id="element-8249" data-mp="1xwqey2huf3b4">
            Prescription medications and temperature-sensitive products receive
            special handling to ensure safety and efficacy:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8250" data-mp="26w54mzq6r9uk">
            <li data-id="element-8251" data-mp="26ukbnejiryyt">
              <strong data-id="element-8252" data-mp="21xk4t1euis6n">Secure Packaging:</strong> All medications are packaged
              securely to prevent damage
            </li>
            <li data-id="element-8253" data-mp="2gmq22ju4i8bw">
              <strong data-id="element-8254" data-mp="2gl58awfmutf3">Temperature Control:</strong> Cold chain products are
              shipped with cooling elements
            </li>
            <li data-id="element-8255" data-mp="2bppug4hmkxio">
              <strong data-id="element-8256" data-mp="2pmv9gtzbh6q2">Confidential Delivery:</strong> Prescription orders are
              delivered discreetly
            </li>
            <li data-id="element-8257" data-mp="2lmch8ytihync">
              <strong data-id="element-8258" data-mp="2lmumum22dp7x">Verification:</strong> ID verification may be required for
              controlled medications
            </li>
          </ul>
        </>
  }, {
    id: 'failed-delivery',
    title: 'Failed Delivery Attempts',
    content: <>
          <p className="mb-4" data-id="element-8259" data-mp="5t110hve0d4p">If delivery cannot be completed:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8260" data-mp="9uw1xl9eoohy">
            <li data-id="element-8261" data-mp="9tkxrkc1teqb">The courier will attempt delivery up to 3 times</li>
            <li data-id="element-8262" data-mp="39aj82n3c5g42">You will be contacted via phone and SMS for each attempt</li>
            <li data-id="element-8263" data-mp="3e942g5vwp5kl">
              After 3 failed attempts, the order will be returned to our
              facility
            </li>
            <li data-id="element-8264" data-mp="3iafqi6z4tiqo">You can arrange for re-delivery or pickup from our store</li>
            <li data-id="element-8265" data-mp="3n15zrvaoi5qn">
              Re-delivery fees may apply for repeated failed delivery attempts
            </li>
          </ul>
          <p className="mt-4" data-id="element-8266" data-mp="2qigrfbqp1ztt">
            To avoid failed deliveries, please ensure your contact information
            and delivery address are accurate and that someone is available to
            receive the package.
          </p>
        </>
  }, {
    id: 'damaged-packages',
    title: 'Damaged or Lost Packages',
    content: <>
          <p data-id="element-8267" data-mp="2e0nsl84dy77n">
            If your package arrives damaged or does not arrive at all, please
            contact us immediately:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8268" data-mp="2911gj20amx0f">
            <li data-id="element-8269" data-mp="242ggb2l1kdbz">
              <strong data-id="element-8270" data-mp="242zvwcn7ypmu">Damaged Package:</strong> Do not accept the delivery. Take
              photos and contact us within 24 hours.
            </li>
            <li data-id="element-8271" data-mp="1z9x2q5mcti76">
              <strong data-id="element-8272" data-mp="1ucwv3q9uw7dy">Lost Package:</strong> If tracking shows delivered but you
              did not receive it, contact us within 48 hours.
            </li>
            <li data-id="element-8273" data-mp="1qcwgo5mrbw6w">
              <strong data-id="element-8274" data-mp="1q98mr5deh7rn">Missing Items:</strong> Report missing items from your
              order within 24 hours of delivery.
            </li>
          </ul>
          <p className="mt-4" data-id="element-8275" data-mp="1gcvumbxi71z0">
            We will investigate the issue and arrange for a replacement or
            refund as appropriate.
          </p>
        </>
  }, {
    id: 'international',
    title: 'International Shipping',
    content: <>
          <p data-id="element-8276" data-mp="1b1cimkst1kq4">
            Currently, we only ship within the Kingdom of Saudi Arabia. We do
            not offer international shipping at this time.
          </p>
          <p className="mt-4" data-id="element-8277" data-mp="163t3zjs735xn">
            For international customers, please check back regularly as we plan
            to expand our delivery coverage in the future.
          </p>
        </>
  }, {
    id: 'contact-shipping',
    title: 'Contact Us',
    content: <>
          <p className="mb-4" data-id="element-8278" data-mp="s7yv30rf8gkj">
            For questions about shipping or to track your order, please contact
            us:
          </p>
          <ul className="list-none space-y-2" data-id="element-8279" data-mp="23op7j1mfu4ml">
            <li data-id="element-8280" data-mp="23rl5gpyactb1">
              <strong data-id="element-8281" data-mp="1yqdwwoobjq3b">Email:</strong> shipping@innovapharmacy.com
            </li>
            <li data-id="element-8282" data-mp="1yshz926kkh1h">
              <strong data-id="element-8283" data-mp="3go0fu0l4oxog">Phone:</strong> +966 920 000 000
            </li>
            <li data-id="element-8284" data-mp="3gmpc20ronpxc">
              <strong data-id="element-8285" data-mp="3gqd939wc6ugt">Hours:</strong> 24/7 Customer Support
            </li>
          </ul>
          <p className="mt-4" data-id="element-8286" data-mp="3ll0maclw42g3">
            Our team is here to ensure your order reaches you safely and on
            time.
          </p>
        </>
  }];
  return <PolicyLayout title="Shipping Policy" description="Learn about our delivery options, timelines, and shipping procedures. We deliver healthcare products safely across Saudi Arabia." lastUpdated="January 15, 2025" sections={sections} seoTitle="Shipping Policy - Innova Pharmacy" seoDescription="Read Innova Pharmacy's Shipping Policy for information on delivery options, timelines, tracking, and coverage across Saudi Arabia. Fast and reliable delivery." canonical="/shipping-policy" data-id="element-8287" data-mp="3cn8a3hbgtawx" />;
}